<template>
  <div>
    <div class="dialog-container">
      <div class="selected-list">
        已选品牌：
        <span v-for="item,index in selectList" :key="index">
          {{item.brandName}}
          <i v-if="index !== selectList.length - 1">、</i>
        </span>
      </div>
      <div class="search-row">
        <div class="search-form">
          品牌
          <el-select v-model="brandParams.parentBrandCode" filterable placeholder="请选择品牌" clearable>
            <el-option :value="item.brandCode" v-for="item,index in brandList" :key="index" :label="item.brandName"></el-option>
          </el-select>子品牌
          <el-input v-model="brandParams.brandName" placeholder="请输入子品牌名称" clearable></el-input>
        </div>
        <div class="handle-box">
          <el-button class="btn btn-red" @click="search">搜索</el-button>
          <el-button class="btn btn-reset" @click="resetSearch">重置</el-button>
        </div>
      </div>
      <!-- 数据列表 -->
      <el-table
        :data="subBrandList"
        border
        :row-key="brandRowKey"
        @select="getSelectBrand"
        @select-all="selectAllBrand"
        class="dialog-table"
        ref="subBrandTable"
      >
        <el-table-column align="center" prop="parentBrandName" label="品牌" min-width="50%" />
        <el-table-column align="center" prop="brandName" label="子品牌" min-width="50%" />
        <el-table-column align="center" type="selection" :reserve-selection="true" width="200px" min-width="50%" />
      </el-table>
      <el-row class="while-data-table-footer" v-if="subBrandList.length">
        <el-col>
          <el-pagination
            background
            :current-page="brandParams.currentPage"
            :page-size="brandParams.pageSize"
            :total="brandParams.total"
            layout="total, prev, pager, next"
            @current-change="handleCurrentChange"
          />
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import tradeApi from '@/api/trade.js'
// import { mapGetters } from 'vuex'
export default {
  props: {
    selectedList: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data () {
    return {
      brandParams: {
        parentBrandCode: '',
        brandName: '',
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      brandList: [],
      subBrandList: [],
      selectList: [], // 选中品牌列表
      selectedSubBrandList: [],
      tmpList: []
    }
  },
  watch: {
    selectedList () {
      this.selectList = JSON.parse(JSON.stringify(this.selectedList)) || []
      this.showBrandSelected()
    }
  },
  created () {
    this.init()
  },
  methods: {
    init () {
      this.queryBrandList()
      this.search()
      this.selectList = JSON.parse(JSON.stringify(this.selectedList)) || []
      this.showBrandSelected()
    },
    // 搜索
    search () {
      this.brandParams.page = 1
      this.getSubBrandList()
    },
    // 获取子品牌列表
    getSubBrandList () {
      tradeApi.getStrSubBrand(this.brandParams).then(res => {
        if (res.data.resultCode === '0') {
          this.brandParams.total = res.data.resultData.pageInfo.totalCounts
          this.subBrandList = res.data.resultData.subBrandList || []
          this.showBrandSelected()
        }
      })
    },
    // 获取品牌下拉列表
    queryBrandList () {
      tradeApi.getStrBrandSelect(this.brandParams).then(res => {
        if (res.data.resultCode === '0') {
          this.brandList = res.data.resultData.brandList
        }
      })
    },
    // 重置搜索条件
    resetSearch () {
      this.brandParams = this.$options.data().brandParams
      this.getSubBrandList()
    },
    // 品牌列表分页
    handleCurrentChange (val) {
      this.brandParams.page = val
      this.getSubBrandList()
    },
    // sku弹窗每行标志位
    brandRowKey (row) {
      return row.brandCode
    },
    // 已勾选 表格对应展示
    showBrandSelected () {
      this.$nextTick(() => {
        this.subBrandList.map(brand => {
          const matchedBrand = this.selectList.find(selectedBrand => {
            return selectedBrand.brandCode === brand.brandCode
          })
          this.$refs.subBrandTable.toggleRowSelection(brand, Boolean(matchedBrand))
        })
      })
    },
    // 选择赠酒SKU
    getSelectBrand (selectList, row) {
      let flag = this.selectList.some((item) => {
        return item.brandCode === row.brandCode
      })
      if (flag) {
        this.selectList.forEach((item, index) => {
          if (item.brandCode === row.brandCode) {
            this.selectList.splice(index, 1)
          }
        })
      } else {
        this.selectList.push(row)
      }
      this.$emit('strSubBrand', this.selectList)
    },
    // 赠酒sku全选
    selectAllBrand (selectList) {
      this.selectList = Object.assign([], selectList)
      this.$emit('strSubBrand', this.selectList)
    }
  }
}
</script>

<style lang="scss" scoped>
.dialog-container {
  .selected-list {
    line-height: 40px;
    color: #000;
  }
  .search-row {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
  }
}
.el-input,
.el-select {
  width: 170px;
  margin: 0 20px 0 10px;
  &::v-deep .el-input__inner {
    height: 30px;
  }
  &::v-deep .el-input__icon {
    line-height: 0;
  }
}
.el-button {
  width: 80px;
  height: 30px;
  padding: 0 20px;
}
.dialog-table {
  ::v-deep .el-table__header-wrapper .el-checkbox__input::after {
    content: '全选';
    position: absolute;
    margin: 0 0 0 10px;
    font-weight: 700;
    color: rgb(144, 147, 153);
  }
}
.dialog-footer {
  text-align: center;
  margin-top: 20px;
}
</style>
